import React from 'react'

import type { IconProps } from '../iconProps'
import { s } from './icon.style'

export const ChevronLeftFillIcon = React.forwardRef<SVGSVGElement, IconProps>(
  ({ size = 16, name = 'icon', color, style, ...props }: IconProps, ref) => {
    return (
      <svg
        viewBox="0 0 24 24"
        css={s}
        style={{ width: size, color, ...style }}
        data-svg-name={name}
        {...props}
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="2" width="20" height="20" rx="10" fill="#333333" />
        <path
          d="M14.8416 15.4083L11.025 11.5833L14.8416 7.75834L13.6666 6.58334L8.66663 11.5833L13.6666 16.5833L14.8416 15.4083Z"
          fill="white"
        />
      </svg>
    )
  },
)
